import ComparePlansModal from "../ComparePlansModal";
import { isSelfStudyUser, updateUser } from "../../services/authUtil";
import PurchasePlanPaywall from "./PurchasePlanPaywall";
import { ReactElement, useState } from "react";
import { fetchStudentProfileAsync } from "../../services/students";
import useUser from "../../hooks/useUser";

type Props = {
  onSuccess?: () => void;
  children?: React.ReactNode;
  triggerContainerClassName?: string;
  onUpgrade: () => void;
  enable?: boolean;
  onClose?: () => void;
  onError?: () => void;
  dialogPortal?: (node: ReactElement) => ReactElement;
  defaultOpen?: boolean;
};

export default function Paywall(props: Props) {
  const user = useUser(true);

  const [reloading, setReloading] = useState(false);
  const reload = async () => {
    if (reloading) {
      return;
    }
    setReloading(true);
    try {
      const { has_pro_access } = await fetchStudentProfileAsync();
      if (has_pro_access) {
        updateUser({
          ...user,
          student: {
            ...user.student,
            has_pro_access,
          },
        });
        props.onSuccess?.();
        return;
      }
    } catch (e) {
      props.onError?.();
    } finally {
      setReloading(false);
    }
  };

  if (isSelfStudyUser(user) && !user.company) {
    return (
      <PurchasePlanPaywall
        defaultOpen={props.defaultOpen}
        dialogPortal={props.dialogPortal}
        onSuccess={() => props.onSuccess?.()}
        {...props}
        reload={reload}
      />
    );
  } else {
    return <ComparePlansModal {...props} />;
  }
}
